import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

type Engagement = {
  month: Date;
  username: string;
  homeStation?: string;
  role?: string;
  groupAncestorCodes?: string[];
  count: number;
};

export function useEngagements() {
  const queryKey = ['engagements'];
  const queryClient = useQueryClient();
  const query = useQuery<Engagement[]>({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        {
          $group: {
            _id: {
              month: {
                $dateTrunc: {
                  date: '$time',
                  unit: 'month',
                  timezone: 'Europe/London',
                },
              },
              user: '$user',
            },
            count: { $sum: 1 },
          },
        },
        {
          $lookup: {
            from: 'people',
            localField: '_id.user',
            foreignField: 'emailAddress',
            pipeline: [
              {
                $graphLookup: {
                  from: 'groups',
                  startWith: '$groupCodes',
                  connectFromField: 'parentCodes',
                  connectToField: 'code',
                  as: 'groupAncestorCodes',
                },
              },
              {
                $project: {
                  _id: 0,
                  homeStation: 1,
                  role: 1,
                  groupAncestorCodes: {
                    $map: {
                      input: '$groupAncestorCodes',
                      as: 'group',
                      in: '$$group.code',
                    },
                  },
                  // groupAncestorCodes: {
                  //   $function: {
                  //     body: function (groups) {
                  //       return groups.reduce(
                  //         (accumulator, group) => ({
                  //           ...accumulator,
                  //           [group.type]: [
                  //             ...(accumulator[group.type] || []),
                  //             group.code,
                  //           ],
                  //         }),
                  //         {},
                  //       );
                  //     },
                  //     args: ['$groupAncestorCodes'],
                  //     lang: 'js',
                  //   },
                  // },
                },
              },
            ],
            as: 'person',
          },
        },
        { $set: { person: { $first: '$person' } } },
        {
          $project: {
            _id: 0,
            month: '$_id.month',
            username: '$_id.user',
            groupAncestorCodes: '$person.groupAncestorCodes',
            homeStation: '$person.homeStation',
            role: '$person.role',
            count: 1,
          },
        },
      ];

      return api.post('pipeline/audits', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
